import React, { useState, useEffect } from "react";
import {
  Form, Input, Select, InputNumber, DatePicker,
  Row, Col, Spin, message,
} from "antd";
import { SwapOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import api from "../services/api";

const { Option } = Select;

// ── Logos programas com cores exatas e gradientes ─────────────────────
const LOGOS_MAP = [
  // ── Nacionais ──────────────────────────────────────────────────────
  { keys: ["livelo"],                    bg: "#e8008b", letra: "LV"  },
  { keys: ["itaú pontos","itau pontos"], bg: "#d48c0c", letra: "IT"  },
  { keys: ["smiles"],                    bg: "#ff6600", letra: "S"   },
  { keys: ["azul fidelidade","azul"],    bg: "#003087", letra: "A"   },
  { keys: ["coopera pj"],                bg: "#007b5e", letra: "CPJ" },
  { keys: ["coopera"],                   bg: "#007b5e", letra: "COO" },
  { keys: ["latam"],                     bg: "#d81a36", letra: "L"   },
  { keys: ["tap miles","tap"],           bg: "#009900", letra: "TAP" },
  { keys: ["max milhas"],                bg: "#1e3a6e", letra: "MM"  },
  { keys: ["hotmilhas"],                 bg: "#cc3300", letra: "HM"  },
  { keys: ["ipiranga"],                  bg: "#f5a800", letra: "IP"  },
  { keys: ["esfera empresas"],           bg: "#8b0000", letra: "EE"  },
  { keys: ["esfera"],                    bg: "#8b0000", letra: "E_"  },
  { keys: ["bank milhas"],               bg: "#0066cc", letra: "BM"  },
  { keys: ["cash milhas"],               bg: "#5a5a5a", letra: "CM"  },
  { keys: ["curtaí","curtai"],           bg: "#e8a000", letra: "CT"  },
  { keys: ["compro suas milhas"],        bg: "#1e3a4a", letra: "CSM" },
  { keys: ["átomos","atomos"],           bg: "#000000", letra: "ÁT"  },
  { keys: ["gpa"],                       bg: "#00aa44", letra: "GPA" },
  { keys: ["pontos caixa"],              bg: "#007b5e", letra: "PC"  },
  { keys: ["caixa empresas"],            bg: "#007b5e", letra: "CE"  },
  { keys: ["sicredi empresarial"],       bg: "#009900", letra: "SCE" },
  { keys: ["sicredi"],                   bg: "#009900", letra: "SC"  },
  { keys: ["dotz"],                      bg: "#ff6600", letra: "DZ"  },
  { keys: ["porto plus"],                bg: "#0057a8", letra: "PP"  },
  { keys: ["inter loop"],                bg: "#ff6b00", letra: "IL"  },
  { keys: ["inter empresas"],            bg: "#ff6b00", letra: "IE"  },
  { keys: ["volare"],                    bg: "#c8102e", letra: "VL"  },
  { keys: ["membership rewards","amex"], bg: "#006fcf", letra: "MR"  },
  { keys: ["safra rewards"],             bg: "#003366", letra: "SR"  },
  { keys: ["suma"],                      bg: "#1e3a4a", letra: "SU"  },
  { keys: ["cressol"],                   bg: "#007b5e", letra: "CR"  },
  { keys: ["banrisul"],                  bg: "#003087", letra: "BR"  },
  { keys: ["unicred"],                   bg: "#009900", letra: "UC"  },
  { keys: ["milhas plus"],               bg: "#e8a000", letra: "M+"  },
  { keys: ["xp pontos"],                 bg: "#1a1a2e", letra: "XP"  },
  { keys: ["nubank"],                    bg: "#820ad1", letra: "NU"  },
  { keys: ["ailos"],                     bg: "#007b5e", letra: "AI"  },
  { keys: ["banestes"],                  bg: "#003087", letra: "BN"  },
  { keys: ["bb empresas"],               bg: "#f5a800", letra: "BB"  },
  { keys: ["itaú empresas","itau empresas"], bg: "#d48c0c", letra: "ITE" },
  { keys: ["pontos btg"],                bg: "#1a1a2e", letra: "BTG" },

  // ── Internacionais ──────────────────────────────────────────────────
  { keys: ["iberia"],                    bg: "#cc0000", letra: "IB"  },
  { keys: ["mileageplus","united"],      bg: "#002244", letra: "UA"  },
  { keys: ["all accor","accor"],         bg: "#1e1050", letra: "AL"  },
  { keys: ["Qantas","qantas"],           bg: "#d51919", letra: "QT"  },
  { keys: ["ihg"],                       bg: "#6a0dad", letra: "IHG" },
  { keys: ["aadvantage","american"],     bg: "#0078d2", letra: "AA"  },
  { keys: ["flying blue"],               bg: "#003087", letra: "FB"  },
  { keys: ["british airways"],           bg: "#2b4090", letra: "BA"  },
  { keys: ["qatar"],                     bg: "#5c0632", letra: "QR"  },
  { keys: ["aeroplan"],                  bg: "#c8102e", letra: "AP"  },
  { keys: ["copa","connectmiles"],       bg: "#0033a0", letra: "CM"  },
  { keys: ["delta"],                     bg: "#c8102e", letra: "DL"  },
  { keys: ["emirates"],                  bg: "#c8102e", letra: "EK"  },
  { keys: ["virgin atlantic","flying club"], bg: "#e8003d", letra: "VS" },
  { keys: ["finnair"],                   bg: "#003580", letra: "AY"  },
  { keys: ["wyndham"],                   bg: "#003087", letra: "WY"  },
];

const getLogo = (nome = "") => {
  const n = nome.toLowerCase();
  for (const l of LOGOS_MAP) {
    if (l.keys.some((k) => n.includes(k))) return l;
  }
  return { bg: "#607d8b", letra: (nome || "??").slice(0, 2).toUpperCase() };
};

const LogoCircle = ({ nome, size = 22 }) => {
  const { bg, letra } = getLogo(nome);
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      width: size, height: size, borderRadius: "50%",
      background: bg, color: "#fff",
      fontSize: size * 0.33, fontWeight: 700, flexShrink: 0,
      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    }}>{letra}</span>
  );
};

// ── Helper FireDAC (mesma do Contas) ─────────────────────────────────────
const extractRows = (data) => {
  if (!data) return [];
  if (data.FDBS) {
    try {
      const tables = data.FDBS.Manager.TableList;
      if (tables?.length > 0 && tables[0].RowList)
        return tables[0].RowList.map((r) => r.Original);
    } catch (e) {}
  }
  if (data.Table && Array.isArray(data.Table)) return data.Table;
  if (Array.isArray(data)) return data;
  return [];
};

// ─── Trava contra dado legado gravado ×1000 (mesma do EntradaManual) ────────
// car_vunitario deve ser o custo POR MILHEIRO (ex.: 0,18 / 15,00 / 76,90).
// Nenhum programa custa > R$100/milheiro, então valores acima disso são
// tratados como escala antiga (×1000) e divididos. Ex.: 76900 -> 76,90.
const normalizaVunitarioMilheiro = (v) => {
  const n = Number(v) || 0;
  return n > 100 ? n / 1000 : n;
};

export default function TransferenciaComParidade({ clienteId: clienteIdProp }) {
  const [form] = Form.useForm();
  const [loading, setLoading]   = useState(false);
  const [cartoes, setCartoes]   = useState([]);
  const [titulares, setTitulares] = useState([]);
  const [cartaoOrig, setCartaoOrig] = useState(null);
  const [paridade, setParidade] = useState(1.0);
  const [clienteId, setClienteId] = useState(null);
  const [dataExpiracao, setDataExpiracao] = useState(null);

  // Pontos a transferir (editável). Independente do saldo real do cartão.
  const [pontosEditaveis, setPontosEditaveis] = useState(0);

  // Percentual de bônus ganho na transferência (ex.: promoção da cia aérea/banco).
  const [bonusPercent, setBonusPercent] = useState(0);

  const formatLocaleNumber = (value) => {
    if (!value && value !== 0) return "";
    return value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // Calcular pontos destino com paridade
  const calcularPontosDestino = (origem, paridade) => {
    if (!paridade || paridade <= 0) return 0;
    // Se paridade = 0,8, então multiplicador = 1/0,8 = 1,25
    const multiplicador = 1 / paridade;
    return Math.round(origem * multiplicador);
  };

  // ── Origem / Destino selecionados (necessários para o cálculo em tempo real) ──
  // IMPORTANTE: subimos os watches para o topo porque agora o DESTINO participa
  // do cálculo (média ponderada), então precisamos do cartão de destino aqui.
  const origemSel  = Form.useWatch("cartaoOrigemId", form);
  const destinoSel = Form.useWatch("cartaoDestinoId", form);

  // Cartão de destino (fonte da verdade do saldo/custo que JÁ existe lá).
  const cartaoDest = cartoes.find((c) => c.car_id === destinoSel) || null;

  // ── ORIGEM ──────────────────────────────────────────────────────────────
  // Saldo REAL do cartão de origem — nunca é alterado pela digitação de pontos.
  const saldoDisponivel = cartaoOrig?.car_saldo_milhas ?? cartaoOrig?.CAR_SALDO_MILHAS ?? 0;
  // Custo médio do milheiro na ORIGEM (com trava anti-legado ×1000).
  const custoMilheiro   = normalizaVunitarioMilheiro(cartaoOrig?.car_vunitario ?? cartaoOrig?.CAR_VUNITARIO ?? 0);

  // ── DESTINO (posição que JÁ existe no cartão de destino) ──────────────────
  const saldoDestinoAtual = cartaoDest?.car_saldo_milhas ?? cartaoDest?.CAR_SALDO_MILHAS ?? 0;
  const custoDestinoAtual = normalizaVunitarioMilheiro(cartaoDest?.car_vunitario ?? cartaoDest?.CAR_VUNITARIO ?? 0);

  // Pontos destino "puros", só pela paridade (sem bônus).
  const pontosDestino = calcularPontosDestino(pontosEditaveis, paridade);

  // Pontos ganhos de bônus, calculados SOBRE os pontos destino (não sobre a origem).
  const pontosBonus = pontosDestino > 0 && bonusPercent > 0
    ? Math.round(pontosDestino * (bonusPercent / 100))
    : 0;

  // Total efetivamente recebido no programa de destino (base + bônus).
  const pontosDestinoFinal = pontosDestino + pontosBonus;

  // Custo total da operação = pontos enviados x custo médio da origem.
  // É o dinheiro que você JÁ gastou. Não muda com paridade nem com bônus.
  const custoTotal = custoMilheiro > 0 ? (pontosEditaveis / 1000) * custoMilheiro : 0;

  // Custo do milheiro APENAS do lote que está entrando no destino (sem misturar
  // com o saldo que já existe lá). Serve de referência/auditoria.
  const custoMilheiroEntrada = custoTotal > 0 && pontosDestinoFinal > 0
    ? custoTotal / (pontosDestinoFinal / 1000)
    : 0;

  // ─── CUSTO MÉDIO PONDERADO NO DESTINO (PMP) ───────────────────────────────
  // ESTE é o número que estava faltando. Mesma lógica do EntradaManual:
  // junta o que JÁ existe no cartão de destino com o que está entrando agora,
  // tudo POR MILHEIRO.
  //   custo total existente = (saldoDestino / 1000) * custoDestino_por_milheiro
  //   custo total entrando  = custoTotal (dinheiro gasto na origem)
  //   PMP = (custo existente + custo entrando) / (saldo final / 1000)
  //
  // Exemplo do usuário:
  //   destino já tem 50.000 @ 76,90  -> custo existente = 50 * 76,90 = 3.845
  //   entra           50.000 @ 72,90 -> custo entrando  = 50 * 72,90 = 3.645
  //   saldo final = 100.000 ; custo final = 7.490
  //   PMP = 7.490 / 100 = R$ 74,90  ✅  (não 93,11)
  const custoDestinoAtualTotal = (saldoDestinoAtual / 1000) * custoDestinoAtual;
  const custoEntradaTotal      = custoTotal;
  const saldoDestinoFinal      = saldoDestinoAtual + pontosDestinoFinal;
  const custoDestinoFinalTotal = custoDestinoAtualTotal + custoEntradaTotal;

  let pmpDestino = saldoDestinoFinal > 0
    ? custoDestinoFinalTotal / (saldoDestinoFinal / 1000)
    : 0;

  // Trava: uma média ponderada fica SEMPRE entre o menor e o maior custo
  // unitário das partes. Só aplica quando as DUAS partes existem — se o destino
  // estava zerado, o PMP é simplesmente o custo do lote que entrou.
  if (saldoDestinoAtual > 0 && pontosDestinoFinal > 0) {
    const unitEntrada = custoEntradaTotal / (pontosDestinoFinal / 1000);
    const lo = Math.min(custoDestinoAtual, unitEntrada);
    const hi = Math.max(custoDestinoAtual, unitEntrada);
    if (pmpDestino < lo) pmpDestino = lo;
    if (pmpDestino > hi) pmpDestino = hi;
  }

  // "Custo do Milheiro Destino" exibido = PMP (com saldo já existente).
  // Se o destino estiver zerado, cai naturalmente no custo do lote que entrou.
  const custoMilheiroDestino = pmpDestino;

  // Ao trocar de cartão de origem, sugere transferir o saldo cheio (usuário pode editar).
  useEffect(() => {
    if (cartaoOrig) {
      setPontosEditaveis(cartaoOrig.car_saldo_milhas || 0);
    } else {
      setPontosEditaveis(0);
    }
  }, [cartaoOrig?.car_id]);

  // Atualiza data de expiração quando o prazo muda
  useEffect(() => {
    const prazo = form.getFieldValue('validade');
    if (prazo && prazo > 0) {
      const data = dayjs().add(prazo, 'month');
      setDataExpiracao(data);
    } else {
      setDataExpiracao(null);
    }
  }, [form.getFieldValue('validade')]);

  // ── Resolve clienteId ─────────────────────────────────────────────────
  useEffect(() => {
    let id = clienteIdProp;
    if (!id) {
      try { const u = JSON.parse(localStorage.getItem("user") || "{}"); id = u.cli_id || u.id; } catch (e) {}
      if (!id) id = parseInt(localStorage.getItem("userID") || "0") || null;
    }
    if (id) { setClienteId(id); carregarDados(id); }
    else message.error("Usuário não autenticado.");
  }, [clienteIdProp]);

  const carregarDados = async (id) => {
    setLoading(true);
    try {
      // 1. Busca todos os titulares do gestor (PesquisaTitular)
      const titRes = await api.get("/ServerPrincipal/PesquisaTitular", { params: { Cliente: id } });
      const titRows = extractRows(titRes.data);

      // 2. Deduplica titulares pelo cli_id (mesma técnica do Contas)
      const seen = new Set();
      const titularesDeduplic = titRows.filter((t) => {
        const k = String(t.cli_id ?? t.CLI_ID ?? "");
        if (!k || k === "0" || seen.has(k)) return false;
        seen.add(k);
        return true;
      });

      // 3. Busca cartões de CADA titular individualmente
      const carResArr = await Promise.all(
        titularesDeduplic.map((t) => {
          const cliId = t.cli_id ?? t.CLI_ID;
          return api.get("/ServerPrincipal/PesquisaCartoes", { params: { Cliente: cliId } })
            .then((res) => ({ cliId, rows: extractRows(res.data), tit: t }))
            .catch(() => ({ cliId, rows: [], tit: t }));
        })
      );

      // 4. Monta lista flat de cartões enriquecidos com dados do titular
      const cartoesFlat = [];
      const seenCar = new Set();
      carResArr.forEach(({ rows, tit }) => {
        rows.forEach((c) => {
          const carKey = String(c.car_id ?? c.CAR_ID ?? "");
          if (!carKey || seenCar.has(carKey)) return;
          seenCar.add(carKey);
          cartoesFlat.push({
            car_id:            c.car_id            ?? c.CAR_ID,
            car_nome_programa: c.car_nome_programa  ?? c.CAR_NOME_PROGRAMA ?? "",
            car_saldo_milhas:  c.car_saldo_milhas   ?? c.CAR_SALDO_MILHAS  ?? 0,
            car_vunitario:     c.car_vunitario      ?? c.CAR_VUNITARIO     ?? 0,
            cli_id:            tit.cli_id           ?? tit.CLI_ID,
            cli_nome:          tit.cli_nome         ?? tit.CLI_NOME        ?? "",
            cli_email:         tit.cli_email        ?? tit.CLI_EMAIL       ?? "",
            cli_cpf:           tit.cli_cpf          ?? tit.CLI_CPF         ?? "",
            cli_telefone:      tit.cli_telefone     ?? tit.CLI_TELEFONE    ?? "",
          });
        });
      });

      setTitulares(titularesDeduplic);
      setCartoes(cartoesFlat);
    } catch (e) {
      message.error("Erro ao carregar dados.");
    } finally {
      setLoading(false);
    }
  };

  const handleOrigemChange = (id) => {
    const cartao = cartoes.find((x) => x.car_id === id);
    setCartaoOrig(cartao || null);
    if (form.getFieldValue("cartaoDestinoId") === id)
      form.setFieldValue("cartaoDestinoId", undefined);
  };

  const destinosDisponiveis = (origemId) =>
    origemId ? cartoes.filter((c) => c.car_id !== origemId) : cartoes;

  // ── Submit ─────────────────────────────────────────────────────────────
  const handleSubmit = async (values) => {
    if (!clienteId) { message.error("Cliente não identificado."); return; }
    if (values.cartaoOrigemId === values.cartaoDestinoId) {
      message.error("Origem e destino devem ser diferentes."); return;
    }
    if (!pontosEditaveis || pontosEditaveis <= 0) {
      message.error("Informe a quantidade de pontos a transferir."); return;
    }
    // Trava de segurança: não permite transferir mais do que o saldo real.
    if (pontosEditaveis > saldoDisponivel) {
      message.error(
        `Pontos a transferir (${pontosEditaveis.toLocaleString("pt-BR")}) maiores que o saldo disponível (${saldoDisponivel.toLocaleString("pt-BR")}).`
      );
      return;
    }
    if (bonusPercent < 0) {
      message.error("O percentual de bônus não pode ser negativo.");
      return;
    }
    setLoading(true);
    try {
      let dataExpiracaoStr;
      let expira;

      if (values.validade && values.validade > 0) {
        expira = 1;
        dataExpiracaoStr = dayjs().add(values.validade, 'month').format("YYYY-MM-DD");
      } else {
        expira = 0;
        dataExpiracaoStr = "2099-12-31";
      }

      // Arredonda o PMP em 2 casas (mesmo padrão do EntradaManual).
      const pmpDestino2 = Math.round(pmpDestino * 100) / 100;

      await api.post("/ServerPrincipal/InserirTransferenciaParidade", {
        IDCliente:            clienteId,
        CartaoOrigem:         values.cartaoOrigemId,
        CartaoDestino:        values.cartaoDestinoId,
        PontosOrigem:         pontosEditaveis,
        Paridade:             paridade,
        PontosDestino:        pontosDestinoFinal,
        PontosDestinoBase:    pontosDestino,
        PercentualBonus:      bonusPercent,
        PontosBonus:          pontosBonus,

        CustoMedioPonderadoDestino: pmpDestino2,   // <- deve virar o novo car_vunitario do destino
        Univalor:                   pmpDestino2,   // alias (mesmo nome de campo do EntradaManual)

        // Custo do lote que entrou, SEM misturar com o saldo já existente (auditoria).
        CustoMilheiroEntrada: Number(custoMilheiroEntrada.toFixed(2)),
        // Mantido por compatibilidade; agora carrega o PMP (custo médio final).
        CustoMilheiroDestino: pmpDestino2,

        CustoTotal:           Number(custoTotal.toFixed(2)),

        Validade:             values.validade || 0,
        DataExpiracao:        dataExpiracaoStr,
        Expira:               expira,
        DataOperacao:         values.dataOperacao ? values.dataOperacao.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
        Observacoes:          values.observacoes || "",
      });
      message.success(
        `Transferência realizada! ${pontosDestinoFinal.toLocaleString("pt-BR")} pontos recebidos ` +
        `(${pontosDestino.toLocaleString("pt-BR")} + ${pontosBonus.toLocaleString("pt-BR")} bônus) • ` +
        `PMP destino: R$ ${formatLocaleNumber(pmpDestino2)}/milheiro`
      );
      form.resetFields();
      setParidade(1.0);
      setCartaoOrig(null);
      setPontosEditaveis(0);
      setBonusPercent(0);
      setDataExpiracao(null);
    } catch (e) {
      message.error(e.response?.data || "Erro ao realizar transferência");
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = !!origemSel && !!destinoSel;

  // Mostrar preview do PMP só quando dá pra calcular de verdade.
  const mostrarPreview = !!cartaoDest && pontosDestinoFinal > 0;

  // ── Helper Option com logo ─────────────────────────────────────────────
  const CartaoOption = ({ c }) => {
    const prog         = c.car_nome_programa || "";
    const primeiroNome = (c.cli_nome || "").split(" ")[0];
    return (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <LogoCircle nome={prog} size={22} />
        {primeiroNome} - {prog}
      </span>
    );
  };

  // ── Estilos ─────────────────────────────────────────────────────────────
  const lbl = { fontSize: 14, color: "#666", fontWeight: 500, marginBottom: 6, display: "block" };
  const inp = { width: "100%", borderRadius: 6, border: "1px solid #d9d9d9", background: "#fafafa", height: 48, fontSize: 16 };
  const dis = { ...inp, background: "#f5f5f5", color: "#999", cursor: "not-allowed" };
  const disDestaque = { ...inp, background: "#f6ffed", color: "#389e0d", fontWeight: 700, cursor: "not-allowed", border: "1px solid #b7eb8f" };
  const fi  = { marginBottom: 18 };

  // Painel de PMP (igual espírito do EntradaManual)
  const previewBoxStyle = { background: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: 6, padding: "12px 14px", marginBottom: 18 };
  const previewRowStyle = { display: "flex", justifyContent: "space-between", fontSize: 13, color: "#555", padding: "2px 0" };
  const previewStrongStyle = { display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 700, color: "#237804", paddingTop: 6, marginTop: 4, borderTop: "1px dashed #b7eb8f" };

  return (
    <div style={{ minHeight: "100vh", background: "#f0f2f5", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 24px" }}>
      <Spin spinning={loading}>
        <div style={{ width: "100%", maxWidth: 1320, borderRadius: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.1)", background: "#fff" }}>

          {/* Header */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "24px 40px 20px", borderBottom: "1px solid #f0f0f0" }}>
            <SwapOutlined style={{ fontSize: 22, color: "#555" }} />
            <span style={{ fontSize: 20, fontWeight: 600, color: "#333" }}>Transferência com Paridade</span>
          </div>

          <div style={{ padding: "32px 40px 40px" }}>
            <Form form={form} layout="vertical" onFinish={handleSubmit}
              initialValues={{ dataOperacao: dayjs(), paridade: "1,0", validade: 24 }}
            >

              {/* ── Origem → Destino ── */}
              <Row gutter={20} align="middle" style={{ marginBottom: 18 }}>
                <Col xs={24} sm={11}>
                  <div style={fi}>
                    <label style={lbl}>Titular/Conta de Origem</label>
                    <Form.Item name="cartaoOrigemId" noStyle rules={[{ required: true }]}>
                      <Select size="large" style={{ width: "100%" }}
                        placeholder="Selecione a origem" loading={loading}
                        onChange={handleOrigemChange}
                      >
                        {cartoes.map((c) => (
                          <Option key={c.car_id} value={c.car_id}>
                            <CartaoOption c={c} />
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
                <Col xs={24} sm={2} style={{ textAlign: "center", paddingTop: 28 }}>
                  <span style={{ color: "#aaa", fontSize: 24 }}>»</span>
                </Col>
                <Col xs={24} sm={11}>
                  <div style={fi}>
                    <label style={lbl}>Titular/Conta de Destino</label>
                    <Form.Item name="cartaoDestinoId" noStyle rules={[{ required: true }]}>
                      <Select size="large" style={{ width: "100%" }}
                        placeholder="Selecione o destino" loading={loading}
                      >
                        {destinosDisponiveis(origemSel).map((c) => (
                          <Option key={c.car_id} value={c.car_id}>
                            <CartaoOption c={c} />
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              {/* ── Saldo + Custo médio ── */}
              <Row gutter={20} style={{ marginBottom: 18 }}>
                <Col xs={24} sm={12}>
                  <div style={fi}>
                    <label style={lbl}>Saldo disponível (origem)</label>
                    <Input size="large" style={dis} readOnly
                      value={cartaoOrig ? saldoDisponivel.toLocaleString("pt-BR") : ""}
                      suffix={<span style={{ color: "#bbb" }}>#</span>}
                    />
                  </div>
                </Col>
                <Col xs={24} sm={12}>
                  <div style={fi}>
                    <label style={lbl}>Custo médio (origem)</label>
                    <Input size="large" style={dis} readOnly
                      value={custoMilheiro > 0 ? formatLocaleNumber(custoMilheiro) : ""}
                      placeholder="0,00" suffix={<span style={{ color: "#bbb" }}>$</span>}
                    />
                  </div>
                </Col>
              </Row>

              <div style={{ borderTop: "1px solid #f0f0f0", margin: "6px 0 20px" }} />

              {/* ── Corpo (2 colunas) ── */}
              <Row gutter={32}>

                {/* Esquerda */}
                <Col xs={24} md={12} style={{ borderRight: "1px dashed #e0e0e0" }}>
                  {/* CAMPO PONTOS ORIGEM - EDITÁVEL (NÃO altera o saldo) */}
                  <div style={fi}>
                    <label style={lbl}>Pontos Origem</label>
                    <InputNumber
                      size="large"
                      style={inp}
                      min={0}
                      step={100}
                      controls={false}
                      value={pontosEditaveis}
                      onChange={(value) => {
                        setPontosEditaveis(value || 0);
                      }}
                      formatter={(value) => value ? value.toLocaleString("pt-BR") : ""}
                      parser={(value) => value ? parseFloat(value.replace(/\./g, '')) : 0}
                    />
                  </div>

                  {/* PARIDADE */}
                  <div style={fi}>
                    <label style={lbl}>Paridade</label>
                    <Row gutter={8} align="middle">
                      <Col flex="1">
                        <InputNumber
                          size="large"
                          style={inp}
                          min={0.01}
                          step={0.1}
                          precision={1}
                          controls={false}
                          value={paridade}
                          onChange={(v) => setParidade(Number(v) || 1)}
                          formatter={(v) => v !== undefined && v !== null ? String(v).replace(".", ",") : ""}
                          parser={(v) => v ? parseFloat(v.replace(",", ".")) : 1}
                        />
                      </Col>
                      <Col style={{ color: "#888", fontSize: 14, whiteSpace: "nowrap" }}>: 1</Col>
                    </Row>
                  </div>

                  {/* % BÔNUS - calculado sobre os Pontos Destino */}
                  <div style={fi}>
                    <label style={lbl}>% Bônus na Transferência</label>
                    <InputNumber
                      size="large"
                      style={inp}
                      min={0}
                      max={1000}
                      step={5}
                      controls={false}
                      value={bonusPercent}
                      onChange={(v) => setBonusPercent(Number(v) || 0)}
                      formatter={(v) => v !== undefined && v !== null ? String(v).replace(".", ",") : ""}
                      parser={(v) => v ? parseFloat(String(v).replace(",", ".")) : 0}
                      addonAfter="%"
                    />
                  </div>

                  <div style={fi}>
                    <label style={lbl}>Custo Total da Operação</label>
                    <Input size="large" style={dis} readOnly
                      value={custoTotal > 0 ? formatLocaleNumber(custoTotal) : ""}
                      placeholder="0,00" suffix={<span style={{ color: "#bbb" }}>$</span>}
                    />
                  </div>

                  <div style={fi}>
                    <label style={lbl}>Data da Operação</label>
                    <Form.Item name="dataOperacao" noStyle>
                      <DatePicker style={inp} format="DD/MM/YYYY" size="large"
                        disabledDate={(c) => c && c > dayjs().endOf("day")}
                      />
                    </Form.Item>
                  </div>

                  <div style={fi}>
                    <label style={lbl}>Observações:</label>
                    <Form.Item name="observacoes" noStyle>
                      <Input.TextArea rows={5} style={{ width: "100%", borderRadius: 6, border: "1px solid #d9d9d9", fontSize: 14, resize: "vertical" }} />
                    </Form.Item>
                  </div>
                </Col>

                {/* Direita */}
                <Col xs={24} md={12}>
                  {/* ─── Painel de PMP no destino (média ponderada em tempo real) ─── */}
                  {mostrarPreview && (
                    <div style={previewBoxStyle}>
                      <div style={previewRowStyle}>
                        <span>Posição atual no destino</span>
                        <span>
                          {saldoDestinoAtual.toLocaleString("pt-BR")} milhas · R$ {formatLocaleNumber(custoDestinoAtualTotal)}
                        </span>
                      </div>
                      <div style={previewRowStyle}>
                        <span>Entrando (base + bônus)</span>
                        <span>
                          +{pontosDestinoFinal.toLocaleString("pt-BR")} milhas · R$ {formatLocaleNumber(custoEntradaTotal)}
                        </span>
                      </div>
                      <div style={previewRowStyle}>
                        <span>Saldo após transferência</span>
                        <span>
                          {saldoDestinoFinal.toLocaleString("pt-BR")} milhas · R$ {formatLocaleNumber(custoDestinoFinalTotal)}
                        </span>
                      </div>
                      <div style={previewStrongStyle}>
                        <span>Custo médio no destino (PMP)</span>
                        <span>R$ {formatLocaleNumber(pmpDestino)} / milheiro</span>
                      </div>
                    </div>
                  )}

                  <div style={fi}>
                    <label style={lbl}>Custo do Milheiro Destino (PMP)</label>
                    <Input size="large" style={custoMilheiroDestino > 0 ? disDestaque : dis} readOnly
                      value={custoMilheiroDestino > 0 ? formatLocaleNumber(custoMilheiroDestino) : ""}
                      placeholder="0,00" suffix={<span style={{ color: custoMilheiroDestino > 0 ? "#389e0d" : "#bbb" }}>$</span>}
                    />
                  </div>

                  {/* PONTOS DESTINO - CALCULADO AUTOMATICAMENTE (só paridade, sem bônus) */}
                  <div style={fi}>
                    <label style={lbl}>Pontos Destino (sem bônus)</label>
                    <Input
                      size="large"
                      style={dis}
                      readOnly
                      value={pontosDestino > 0 ? pontosDestino.toLocaleString("pt-BR") : ""}
                      placeholder="0"
                      suffix={<span style={{ color: "#bbb" }}>#</span>}
                    />
                  </div>

                  {/* PONTOS BÔNUS - calculado sobre Pontos Destino */}
                  <div style={fi}>
                    <label style={lbl}>Pontos Bônus (+{bonusPercent || 0}%)</label>
                    <Input
                      size="large"
                      style={dis}
                      readOnly
                      value={pontosBonus > 0 ? `+ ${pontosBonus.toLocaleString("pt-BR")}` : ""}
                      placeholder="0"
                      suffix={<span style={{ color: "#bbb" }}>#</span>}
                    />
                  </div>

                  {/* TOTAL RECEBIDO - destaque em verde */}
                  <div style={fi}>
                    <label style={lbl}>Total Recebido no Destino</label>
                    <Input
                      size="large"
                      style={disDestaque}
                      readOnly
                      value={pontosDestinoFinal > 0 ? pontosDestinoFinal.toLocaleString("pt-BR") : ""}
                      placeholder="0"
                      suffix={<span style={{ color: "#389e0d" }}>#</span>}
                    />
                  </div>

                  {/* VALIDADE - COM OPÇÃO NÃO EXPIRA */}
                  <div style={fi}>
                    <label style={lbl}>Validade</label>
                    <Form.Item name="validade" noStyle>
                      <Select 
                        size="large" 
                        style={{ width: "100%" }}
                        onChange={() => {
                          const prazo = form.getFieldValue('validade');
                          if (prazo && prazo > 0) {
                            const data = dayjs().add(prazo, 'month');
                            setDataExpiracao(data);
                          } else {
                            setDataExpiracao(null);
                          }
                        }}
                      >
                        <Option value={0}>Não Expira</Option>
                        <Option value={12}>12 meses</Option>
                        <Option value={24}>24 meses</Option>
                        <Option value={36}>36 meses</Option>
                        <Option value={48}>48 meses</Option>
                        <Option value={60}>60 meses</Option>
                      </Select>
                    </Form.Item>
                  </div>

                  {/* DATA DE EXPIRAÇÃO - MOSTRA CALCULADA */}
                  <div style={fi}>
                    <label style={lbl}>Data de Expiração</label>
                    <DatePicker
                      size="large"
                      style={dis}
                      format="DD/MM/YYYY"
                      placeholder={dataExpiracao ? "Calculada automaticamente" : "Não expira"}
                      disabled
                      value={dataExpiracao}
                    />
                  </div>
                </Col>
              </Row>

              {/* Submit */}
              <Form.Item style={{ marginBottom: 0, marginTop: 16 }}>
                <button type="submit" disabled={loading || !isFormValid}
                  style={{
                    width: "100%", height: 46,
                    background: isFormValid ? "#1677ff" : "#bfbfbf",
                    border: "none", borderRadius: 6, color: "#fff",
                    fontSize: 15, fontWeight: 600, letterSpacing: "0.05em",
                    cursor: isFormValid ? "pointer" : "not-allowed",
                  }}
                >
                  {loading ? "PROCESSANDO..." : isFormValid ? "CONFIRMAR TRANSFERÊNCIA" : "PREENCHA OS DADOS!"}
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Spin>
    </div>
  );
}